// extracted by mini-css-extract-plugin
export default {"hwaFooter":"HWAFooter_hwaFooter__IDvD9","horzList":"HWAFooter_horzList__8tQOW"};